/**
 * Shared image/GIF/video URL detection — used everywhere a gallery mixes
 * static images with animated GIFs and uploaded video clips in one flat
 * string[] (artist.images, user galleryMedia). GIFs render fine through the
 * existing <img>/<Image> path, so only video needs a distinct branch.
 */
export function isVideoUrl(url: string): boolean {
  if (!url) return false;
  if (url.startsWith('data:video/')) return true;
  return /\.(mp4|webm|mov|m4v)(\?|#|$)/i.test(url);
}
